import env from '@app/environment'

export const PUBLIC_CHANNEL_ID = env.PUBLIC_CHANNEL_ID

export const INCOGNITO_AVATAR_IMAGE = '/assets/images/incognito-avatar.png'
export const USER_CACHE_KEY = 'vb_user_cache'
